import React, { useState } from 'react';
import { signInWithEmailAndPassword, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { auth, db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';
import '../../stylesheets/HomePage.css';
import MKlogo from '../../img/Icons/MarketZLogo.png';
import { useAuth } from '../../AuthContext';

const Login = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setUser } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await setPersistence(auth, browserLocalPersistence);
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      console.log('Usuario logueado con éxito:', user);
      const userDoc = await getDoc(doc(db, 'users', user.uid));

      if (userDoc.exists()) {
        const userData = userDoc.data();
        setError('');
        setUser({ ...user, ...userData });
        onClose();
      } else {
        setError('No se pudo encontrar el nombre de usuario.');
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error.message);
      setError('Credenciales incorrectas. Por favor, intenta nuevamente.');
    }
  };

  return (
    <div className='Login-Form-Cont'>
      <div className='Log-container'>
        <img src={MKlogo} alt='' className='MKZ-Icon-re' />
        <h1>¿Ya tienes cuenta?, ¡Inicia sesión!</h1>
      </div>
      <form className='login-form' onSubmit={handleLogin}>
        <div className='field-container'>
          <div className='txt-container'>
            <h2 className='field-txt'>Email</h2>
          </div>
          <div className='input-container'>
            <input
              type='email'
              className='input'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
        </div>
        <div className='field-container'>
          <div className='txt-container'>
            <h2 className='field-txt'>Contraseña</h2>
          </div>
          <div className='input-container'>
            <input
              type='password'
              className='input'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <div className='submit-container'>
          <button className='submit-btn' type='submit'>
            Iniciar Sesión
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
